import React from 'react';
import $ from 'jquery';
import _ from 'lodash';
import AppStore from '../stores/AppStore';
import AppActions from '../actions/AppActions';
import TemplateData from '../utility/getTemplateData';
import Amount from '../components/amount';
import Calculator from '../components/calculator';


class AmountWrapper extends React.Component {
	constructor() {
		super();

		const currencyObj = JSON.parse(document.getElementById('currencyLists').innerHTML || {});
		const { currencies: currencyLists, symbols: currencySymbols } = currencyObj || {};

		let userCountry = TemplateData.donorIpCountry;
		let availableCurrencies = currencyLists[userCountry] || currencyLists.US;
		let userAmountCode = availableCurrencies[0];
		let charityAmountCode = AppStore.getDonationCode();
		let isEditable = !!TemplateData.donationAmountEditable;
		let isCalculator =
			isEditable &&
			userAmountCode !== charityAmountCode &&
			(TemplateData.showCrossBorderCalculator || TemplateData.isCorpIp);


		this.state = {
			charityAmountCode,
			charityAmount: AppStore.getDonationAmount() || '',
			charityAmountSymbol: AppStore.getDonationSymbol(),
			charityDisabled: false,

			userCountry,
			userAmountCode,
			userAmount: '',
			userDisabled: false,

			availableCurrencies,
			currencySymbols,
			isCalculator,
			decimalPoint: TemplateData.donationDecimalPoint || '.',
			conversionRate: '',
			isAmountEditable: isEditable
		};
	}

	componentDidMount() {
		const startingAmount = parseFloat(this.state.charityAmount);
		if (startingAmount) {
			this.handleCharityAmountChange(startingAmount.toFixed(2));
		}
	}

	normalizeAmount(amount) {
		amount = `${amount}`;
		amount = parseFloat(amount.replace(',', '.'));
		return isNaN(amount) ? 0 : amount;
	}

	setAppAmount(amount) {
		AppActions.changeAmount({
			amount: this.normalizeAmount(amount).toFixed(2)
		});
	}

	getConversionRate(state, exchangeRate) {
		let rate = exchangeRate.base_currency_code === state.userAmountCode ?
			exchangeRate.quote_amount : 1 / exchangeRate.quote_amount;
		return rate.toFixed(2);
	}

	getConversionRequest(state, params, callback) {
		this.getConversionRequest = _.debounce((st, par, fn) => {
			const queryParams = {
				fromCountry: st.userCountry,
				fromCurrency: st.userAmountCode,
				toCurrency: st.charityAmountCode,
				...par
			};

			if (queryParams.fromAmount) {
				queryParams.fromAmount = this.normalizeAmount(queryParams.fromAmount);
			} else {
				queryParams.toAmount = this.normalizeAmount(queryParams.toAmount);
			}

			const url = '/donate/calculate-foreign-exchange';
			Promise.resolve($.post(url, queryParams)).then(({ result }) => {
				fn(result);
			}).catch(() => {
				let amount = queryParams.fromAmount || queryParams.toAmount || '';
				amount += '';
				fn({
					target: { value: amount },
					source: { value: amount },
					exchange_rate: {
						base_currency_code: queryParams.userAmountCode,
						quote_amount: 1
					}
				});
			});
		}, 500);

		this.getConversionRequest(state, params, callback);
	}

	getConversion(state, params, fn) {
		// Don't make conversions on the server if the currency is the same.
		if (state.userAmountCode === state.charityAmountCode) {
			const amount = params.fromAmount || params.toAmount || '';
			fn({
				target: { value: amount },
				source: { value: amount },
				exchange_rate: {
					base_currency_code: state.userAmountCode,
					quote_amount: 1
				}
			});
		} else {
			this.getConversionRequest(state, params, fn);
		}
	}

	handleAmountChange(amount) {
		this.setState({ charityAmount: amount });
		this.setAppAmount(amount);
	}

	handleUserAmountChange(amount) {
		let snapshot = {
			userAmount: amount,
			charityDisabled: true
		};
		let state = { ...this.state, ...snapshot };
		this.setState(snapshot);

		this.getConversion(state, {
			fromAmount: state.userAmount
		}, ({ target, exchange_rate }) => {
			this.setState({
				conversionRate: this.getConversionRate(state, exchange_rate),
				charityAmount: target.value,
				charityDisabled: false
			});
			this.setAppAmount(target.value);
		});
	}

	handleUserCurrencyChange(currencyCode) {
		let snapshot = {
			userAmountCode: currencyCode,
			charityDisabled: true
		};
		let state = { ...this.state, ...snapshot };
		this.setState(snapshot);

		this.getConversion(state, {
			fromAmount: state.userAmount
		}, ({ target, exchange_rate }) => {
			state.charityAmount = target.value;
			this.setState({
				conversionRate: this.getConversionRate(state, exchange_rate),
				charityAmount: state.charityAmount,
				charityDisabled: false
			});
			this.setAppAmount(target.value);
		});
	}

	handleCharityAmountChange(amount) {
		let snapshot = {
			charityAmount: amount,
			userDisabled: true
		};
		let state = { ...this.state, ...snapshot };
		this.setState(snapshot);

		this.getConversion(state, {
			toAmount: state.charityAmount
		}, ({ source, exchange_rate }) => {
			this.setState({
				conversionRate: this.getConversionRate(state, exchange_rate),
				userAmount: source.value,
				userDisabled: false
			});
			this.setAppAmount(state.charityAmount);
		});
	}

	render() {
		return (<div className="amount-wrapper">
			{this.state.isCalculator ?
				<Calculator
					availableCurrencies={this.state.availableCurrencies}
					charityAmountSymbol={this.state.charityAmountSymbol}
					currencySymbols={this.state.currencySymbols}
					decimalPoint={this.state.decimalPoint}
					conversionRate={this.state.conversionRate}
					fromAmount={this.state.userAmount}
					fromCode={this.state.userAmountCode}
					fromDisabled={this.state.userDisabled}
					toAmount={this.state.charityAmount}
					toCode={this.state.charityAmountCode}
					toDisabled={this.state.charityDisabled}
					handleFromChange={this.handleUserAmountChange.bind(this)}
					handleFromCurrencyChange={this.handleUserCurrencyChange.bind(this)}
					handleToChange={this.handleCharityAmountChange.bind(this)}
				/> :
				<Amount
					amount={this.state.charityAmount}
					symbol={this.state.charityAmountSymbol}
					code={this.state.charityAmountCode}
					decimalPoint={this.state.decimalPoint}
					isEditable={this.state.isAmountEditable}
					handleAmount={this.handleAmountChange.bind(this)}
				/>
			}
		</div>);
	}
}

export default AmountWrapper;



// WEBPACK FOOTER //
// ./components/amountWrapper.js